// export const BASE_URL = 'http://10.28.1.122:3000';
// export const APP_URL = 'http://10.28.1.122:3000';
export const APP_URL = 'https://app.hinchpm.co.uk';
export const BASE_URL = 'https://api.hinchpm.co.uk';
//export const APP_URL = 'https://staging.hinchpm.com';
//export const BASE_URL = 'https://apistaging.hinchpm.com';
// export const BASE_URL = 'https://southapi.hinchpm.com';
// export const APP_URL = 'https://south.hinchpm.com';
//export const APP_URL = 'http://localhost:3000';
//export const BASE_URL = 'http://localhost:3003';

export const REACT_APP_VAPID_PUBLIC_KEY='BCjbsGF4R7NMVABrr_jpqFgAv0jy0UdVExygrQsyMSziqIw90nTPV6Hz1Q5IKK4Ay2plP55DeDhE4JW09oGWv5k='
export const HOME = '/';
export const SIGN_IN = '/signin';
export const DASHBOARD = '/dashboard';
export const ACCOUNT = '/account';
export const FORGOT_PASSWORD = '/resetnewpassword';
export const CHANGE_PASSWORD = '/changepassword';
export const CHANGE_EMAIL = '/change_email';
export const PROPERTIES = '/properties';
export const ADMIN = '/admin';
export const AGENT = '/agent';
export const CLERK = '/clerk';
export const COMPANY = '/company';
export const INSPECTION = '/inspection';
export const ADMIN_PROFILE = '/admin/profile';
export const AGENT_PROFILE = '/agent/profile';
export const CLERK_PROFILE = '/clerk/profile';
export const COMPANY_PRICE_LIST = '/company/price_list';
export const CLERK_PRICE_LIST = '/clerk/price_list';
export const REPORT = '/report';
export const INVOICE = '/account/invoice';
export const REMITTANCE = '/account/remittance';
export const EXPENSE = '/account/expense';
export const REPORT_MODULE = '/report/module';
export const CUSTOM_REPORT = '/report/custom_report';
export const SETTINGS = '/user/settings';
export const REPORT_VIEWER = '/rv';
export const PV_REPORT_VIEWER = '/pvrv';
export const CUSTOMER_SERVICE = '/customer_service';
export const SCHEDULE_OF_CONDITIONS = '/soc';
export const VISUAL_ELEC = '/visual_elec';
export const PROPERTY_VISIT = '/property_visit';
export const EXPENSES_GENERATOR = '/expenses_generator';
export const CLERK_DISTRIBUTION = '/clerk_distribution';
export const PRICE_LISTS = '/price_lists';



// WEBPACK FOOTER //
// ./src/constants/app_routes.js